export const SCRAP_CARS_STEP_KEY = {
    BASIC_DETAILS: "basicDetails",
    PRICE_ESTIMATE: "priceEstimate",
    SELF_INSPECTION: "selfInspection",
    FINAL_PRICE: "finalPrice"
};

export const SCRAP_CARS_TAB_LIST = [
    {
        heading: "Basic details",
        key: SCRAP_CARS_STEP_KEY.BASIC_DETAILS
    },
    {
        heading: "Price estimate",
        key: SCRAP_CARS_STEP_KEY.PRICE_ESTIMATE
    },
    {
        heading: "Self inspection",
        key: SCRAP_CARS_STEP_KEY.SELF_INSPECTION
    },
    {
        heading: "Final price",
        key: SCRAP_CARS_STEP_KEY.FINAL_PRICE
    }
];

export const SCRAP_BENEFITS_MAPPING = {
    PRICE_ESTIMATE: "price_estimate",
    ADDITIONAL_BENEFITS: "additional_benefits",
    TREES_REVIVE: "trees_revive"
};

export const ADDITIONAL_BENEFITS_INFO = [
    "Get up to ₹20,000 off on road tax",
    "Discounts up to ₹5,000 on new car’s registration",
    "Save up to ₹75,000 on fuel costs"
];

export const QUESTION_KEY_MAP = {
    TYRES_COUNT: "tyres_count"
};

export const DISCOUNT_INFO = [
    "Get upto ₹25,000 off on road tax",
    "Discounts upto ₹5,000 on new car’s registration",
    "Save upto ₹75,000 on fuel costs"
];

export const BENEFITS_MAPPING = {
    DISCOUNT: "discount",
    TREES: "trees"
};

export const COLOR_TOKEN = {
    greenPrimary: "#216DFE",
    greenSecondary: "#E9FAF2"
};
